//Reference: EN055

import { Mappeable } from './mappeable.model';
import * as _ from 'lodash';

export class ExpensesSource extends Mappeable {

    budgetExpenseTypeId: number;
    txtTypeBudgetExpense: string;
    mrkActive: boolean;
    imputable: boolean;
    budgetExpenseTypeChilds: any;
    budgetExpenseTypeFather: any;
    typeConceptImputationFatherId: any;

    constructor(o) {
        super(o);
        this.mrkActive = this.mrkActive ??  false 
        this.imputable = this.imputable ??  false 
        //this.budgetExpenseTypeChilds = this.budgetExpenseTypeChilds ??  null 
    }

    public mapToBack() {
        return {
            txtTypeBudgetExpense: this.txtTypeBudgetExpense,
            mrkActive: this.mrkActive,
            imputable: this.imputable,
            budgetExpenseTypeFather: this.typeConceptImputationFatherId ? { budgetExpenseTypeId: this.typeConceptImputationFatherId } : null,
        }
    }

}